import { Search, Skull, Flame, LayoutGrid, Download } from "lucide-react";
import { formatDownloads } from "@/lib/api";

export const Header = ({ search, onSearch, stats, view, onNavigate }) => {
  const tabs = [
    { id: "vault", label: "Browse Mods", icon: LayoutGrid },
    { id: "gzdoom", label: "Get GZDoom", icon: Download },
  ];
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-[#0a0a0c]/90 backdrop-blur-md border-b border-[#2e2a36]"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 py-3 flex items-center gap-4 sm:gap-6">
        <button
          type="button"
          data-testid="logo-link"
          onClick={() => onNavigate("vault")}
          className="flex items-center gap-2 shrink-0 group"
        >
          <div className="relative">
            <Skull
              className="w-7 h-7 sm:w-8 sm:h-8 text-[#ef4444] flicker"
              strokeWidth={2.5}
            />
          </div>
          <div className="leading-none text-left">
            <span className="font-pixel text-base sm:text-lg text-white tracking-tight">
              WAD<span className="text-[#84cc16]">DROP</span>
            </span>
            <div className="hidden sm:block text-[9px] font-mono tracking-[0.25em] text-gray-500 uppercase mt-0.5">
              Doom Mods, One Click Away
            </div>
          </div>
        </button>

        {view === "vault" ? (
          <div className="flex-1 max-w-xl relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
            <input
              data-testid="mod-search-input"
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder="Search WADs, authors, tags..."
              className="w-full bg-[#121115] border border-[#2e2a36] focus:border-[#ef4444] outline-none rounded-md pl-10 pr-4 py-2.5 text-sm text-gray-200 placeholder:text-gray-600 transition-colors font-mono"
            />
          </div>
        ) : (
          <div className="flex-1" />
        )}

        {stats && (
          <div className="hidden lg:flex items-center gap-6 shrink-0">
            <div className="text-right" data-testid="stat-total-wads">
              <div className="font-pixel text-lg text-[#84cc16]">
                {stats.total_wads}
              </div>
              <div className="text-[9px] font-mono tracking-widest text-gray-500 uppercase">
                WADs
              </div>
            </div>
            <div className="text-right" data-testid="stat-total-downloads">
              <div className="font-pixel text-lg text-[#f59e0b] flex items-center gap-1">
                <Flame className="w-4 h-4" />
                {formatDownloads(stats.total_downloads)}
              </div>
              <div className="text-[9px] font-mono tracking-widest text-gray-500 uppercase">
                Downloads
              </div>
            </div>
          </div>
        )}
      </div>

      <nav className="border-t border-[#2e2a36] bg-[#0a0a0c]/60">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 flex items-center gap-1">
          {tabs.map((t) => {
            const Icon = t.icon;
            const active = view === t.id;
            return (
              <button
                key={t.id}
                data-testid={`nav-tab-${t.id}`}
                onClick={() => onNavigate(t.id)}
                className={`flex items-center gap-2 px-4 py-3 font-mono text-[11px] uppercase tracking-wider border-b-2 -mb-px transition-colors ${
                  active
                    ? "border-[#ef4444] text-white"
                    : "border-transparent text-gray-500 hover:text-gray-300"
                }`}
              >
                <Icon className="w-3.5 h-3.5" />
                {t.label}
              </button>
            );
          })}
        </div>
      </nav>
    </header>
  );
};
